import { Card, CardContent } from '@/_shared/components/ui/card';

interface PlanStatsCardsProps {
  eventCount: number;
  propertyCount: number;
  sourceCount: number;
  prCount: number;
}

export function PlanStatsCards({
  eventCount,
  propertyCount,
  sourceCount,
  prCount,
}: PlanStatsCardsProps): React.ReactElement {
  const stats = [
    { label: 'Event changes', value: eventCount },
    { label: 'Property changes', value: propertyCount },
    { label: 'Sources', value: sourceCount },
    { label: 'Pull requests', value: prCount },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
      {stats.map((stat) => (
        <Card key={stat.label} className="py-4">
          <CardContent className="text-center">
            <p className="text-2xl font-bold text-foreground">{stat.value}</p>
            <p className="text-xs text-muted-foreground">{stat.label}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
